module.exports = __webpack_public_path__ + "static/img/Wallpaper.0d37f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutehub/imgs/browse/Wallpaper.jpg
// module id = 2320
// module chunks = 0